import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button } from '@domain-group/suit-theme'

import type { UseBrowseCampaignComparablesModalPayload } from '../../hooks/useBrowseCampaignComparablesModal'

import Filter from './Filter'

const getButtonText = (activeFiltersCount: number) => {
  if (activeFiltersCount === 0){
    return 'Close Filters'
  }

  return `Save ${activeFiltersCount} ${activeFiltersCount === 1 ? 'Filter' : 'Filters'}`
}

interface FilterProps {
  hookPayload: UseBrowseCampaignComparablesModalPayload,
}

const Filters = (props: FilterProps) => {
  const { hookPayload } = props

  const {
    activeFiltersCount,
    browseComparableType,
    callbacks: { changeFilter, resetFilters, setModalState },
    filtersArray,
    showFilters,
  } = hookPayload

  if (!showFilters){
    return (
      <Button
        buttonStyle="secondaryEdit"
        icon={!activeFiltersCount ? <FontAwesomeIcon icon={faPlus} /> : null}
        onClick={() => setModalState({ showFilters: true })}
        // @ts-expect-error
        marginTop="medium"
        size="medium"
        width="auto"
      >
        {activeFiltersCount ? `Manage Filters (${activeFiltersCount} Active)` : 'Add Filters'}
      </Button>
    )
  }

  return (
    <Box flexDirection="column" flexShrink={0}>
      {filtersArray.map(filter => (
        <Filter
          browseComparableType={browseComparableType}
          changeFilter={changeFilter}
          filter={filter}
          key={filter.id}
        />
      ))}

      <Button
        buttonStyle="secondaryUtility"
        // @ts-expect-error
        marginTop="large"
        onClick={resetFilters}
        size="medium"
        width="auto"
      >
        Clear All Filters
      </Button>

      <Button
        buttonStyle="secondaryEdit"
        // @ts-expect-error
        marginTop="medium"
        onClick={() => setModalState({ showFilters: false })}
        size="medium"
        width="auto"
      >
        {getButtonText(activeFiltersCount)}
      </Button>
    </Box>
  )
}

export default Filters
